import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useSessionStorage } from 'usehooks-ts';
import _ from 'lodash';
import {
  MARK_VISIBILITY_GROUP_KEY,
  SEARCH_RESULT,
} from '../../../shared/constants';
import { VisibilityGroupString } from '../../notes/types';
import { ContentArea } from '../types';
import getContentAreasFromPattern from '../functions/getContentAreasFromPattern';
import { useAppSelector } from '../../../redux/hooks';
import { selectActiveVersion } from '../../../redux/store/content/slice';

/**
 * Converts the search words found in the HTML content of the version to search content areas.
 *
 * @returns {ContentArea[]} An array of `ContentArea` objects containing the search word patterns.
 */
function useMakeSearchContentAreas(): ContentArea[] {
  const [activeMarkVisibilityGroup, setActiveMarkVisibilityGroup] =
    useSessionStorage<VisibilityGroupString | null>(
      MARK_VISIBILITY_GROUP_KEY,
      null,
    );
  const version = useAppSelector(selectActiveVersion);
  const [searchWordAreas, setSearchWordAreas] = useState<ContentArea[]>([]);
  const url = useLocation();

  useEffect(() => {
    const splittedUrl = _.split(url.search, '&k=');
    const searchWords = _.split(splittedUrl[1] ?? [], '&')[0]
      .split(',')
      .map((w) => decodeURIComponent(w))
      .filter((w) => w !== '')
      .sort((w1, w2) => w2.length - w1.length);

    const contentAreas = getContentAreasFromPattern({
      content: version.htmlContent || '',
      patternList: searchWords,
      classNames: [SEARCH_RESULT, 'border', 'border-2', 'border-primary'],
      tagName: 'mark',
    }) as ContentArea[];

    setSearchWordAreas(contentAreas?.length ? contentAreas : []);

    if (searchWords.length && activeMarkVisibilityGroup !== null) {
      setActiveMarkVisibilityGroup(null);
    }
  }, [url, version]);

  return searchWordAreas;
}

export default useMakeSearchContentAreas;
